// @ts-check
import {SVG_ICON_NAMES} from 'common/components/svg-icon';

/** @typedef {import('./items-menu-types').Section} Section */

/** @type{string[]} */
export const selectRangeOptions = [`in the last`, `between`, `since`, `on`, `after`];

/** @type{string[]} */
export const selectAnimalOptions = [
  `🐙Overcritical Octopus`,
  `🐠 Ferocious Fish`,
  `🐳 Whopping Whale`,
  `🐡 Blissful Blowfish`,
  `🦑 Sassy Squid`,
];

/** @type{Section[]} */
export const selectRoleSections = [
  {
    items: [
      {label: `Owner`, subLabel: `Full access to everything`, wrapSubLabel: true},
      {
        label: `Admin`,
        subLabel: `Full access to everything, but has no deletion or security management privileges`,
        wrapSubLabel: true,
        tooltip: {
          text: `Additional information about the admin`,
        },
      },
      {
        label: `Consumer`,
        subLabel: `View reports`,
        wrapSubLabel: true,
        isDisabled: true,
        tooltip: {
          text: `Unable to switch role to a consumer`,
        },
      },
      {label: `Analyst`, subLabel: `View and save reports`, wrapSubLabel: true},
    ],
  },
];

/** @type{Section[]} */
export const selectSubSections = [
  {
    items: [
      {
        label: `Email`,
        icon: `type-text`,
        subSections: [
          {
            label: `Loading Sub Section`,
            items: [],
            isLoading: true,
          },
        ],
      },
      {
        label: `Nested Props`,
        icon: `table`,
        subSections: [
          {
            label: `Nested Section`,
            items: [
              {
                icon: `type-text`,
                label: `mp_country_code`,
              },
              {
                icon: `type-text`,
                label: `Agriculture`,
                isDisabled: true,
              },
              {
                icon: `type-text`,
                label: `Arable (%)`,
              },
              {
                icon: `type-text`,
                label: `Area (sq. mi.)`,
              },
              {
                icon: `type-text`,
                label: `Birthrate`,
              },
              {
                icon: `type-text`,
                label: `Climate`,
              },
              {
                icon: `type-text`,
                label: `Coastline (coast/area ratio)`,
              },
              {
                icon: `type-text`,
                label: `Country`,
              },
              {
                icon: `type-text`,
                label: `Crops (%)`,
              },
              {
                icon: `type-text`,
                label: `Deathrate`,
              },
              {
                icon: `type-text`,
                label: `GDP ($ per capita)`,
              },
              {
                icon: `type-text`,
                label: `Infant mortality (per 1000 births)`,
              },
              {
                icon: `type-date`,
                label: `$last_seen`,
              },
              {
                icon: `type-text`,
                label: `Literacy (%)`,
              },
              {
                icon: `type-text`,
                label: `Net migration`,
              },
              {
                icon: `type-text`,
                label: `Other (%)`,
              },
              {
                icon: `type-text`,
                label: `Phones (per 1000)`,
              },
              {
                icon: `type-text`,
                label: `Pop. Density (per sq. mi.)`,
              },
              {
                icon: `type-text`,
                label: `Population`,
              },
              {
                icon: `type-text`,
                label: `Region`,
              },
              {
                icon: `type-text`,
                label: `Service`,
              },
            ],
          },
        ],
      },
      {
        label: `Error`,
        icon: `type-boolean`,
      },
      {
        label: `User Ids`,
        icon: `type-list`,
      },
      {
        label: `Created`,
        icon: `type-date`,
      },
    ],
  },
];

/** @type{Section[]} */
export const selectIconSections = [
  {
    items: SVG_ICON_NAMES.map((icon) => ({label: icon, icon})),
  },
];
